import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import Loader from "../../../../Utils/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Pencil, Trash2, UserPlus, PlusSquare, LogOut } from "lucide-react";
import { useDispatch } from "react-redux";
import Modal from "../../../../Components/ExtraComponents/Modal";
import {
  Get_All_Strategy,
  Get_client_By_strategy_Id,
  Add_And_Remove_Strategy_To_Client,
  UpDate_strategy_Id,
  Remove_Strategy_BY_Id,
  Get_Strategy_Logs,
} from "../../../../ReduxStore/Slice/Admin/StrategySlice";
import { GO_TO_DASHBOARDS } from "../../../../ReduxStore/Slice/Admin/AdminSlice";

import toast from "react-hot-toast";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";
import Swal from "sweetalert2";

const ServicesList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_token = JSON.parse(localStorage.getItem("user_details"))?.token;
  const permission = JSON.parse(localStorage.getItem("permission"));

  const [getClient, setGetClient] = useState([]);
  const [startegyClientIds, setStartegyClientIds] = useState([]);
  const [startegyClientIdsDelete, setStartegyClientIdsDelete] = useState([]);
  const [startegyIds, setStartegyIds] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [showModal2, setshowModal2] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [oneStrategyClient, setOneStrategyClient] = useState([]);
  const [showStrategyName, setShowStrategyName] = useState("");
  const [AllStrategy, setAllStrategy] = useState({ loading: true, data: [] });
  const [StrategyLogs, setStrategyLogs] = useState([]);
  const [isSpinning, setIsSpinning] = useState(false);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [showLogDescModal, setShowLogDescModal] = useState(false);
  const [selectedLogDescription, setSelectedLogDescription] = useState("");


  const [getServicesName, setServicesName] = useState({
    loading: true,
    data: [],
  });
  const [isLoading, setIsLoading] = useState(true);

  const data = async () => {
    await dispatch(
      Get_All_Strategy({
        req: {
          page: "1",
          limit: "100",
        },
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllStrategy({
            loading: false,
            data: response.data,
          });
        }
        setOriginalData(response.data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    data();
  }, [refresh]);

  const columns = [

    {
      name: "Strategy Image",
      selector: (row) => row.strategy_image,
      cell: (row) => (
        <img
          src={
            row.strategy_image
              ? row.strategy_image
              : "https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
          }
          alt="strategy-logo"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "contain",
            borderRadius: "5px",
            border: "1px solid #e5e5e5",
            background: "#f8f8f8",
          }}
        />
      ),
      width: "150px",
    },

    {
      name: "Strategy Name",
      selector: (row) => row.strategy_name,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={row.strategy_name}
        >
          {row.strategy_name || "-"}
        </div>
      ),
      sortable: true,
      width: "10%",
    },

    {
      name: "Indicator",
      selector: (row) => row.strategy_indicator,
      cell: (row) => <span>{row.strategy_indicator || "-"}</span>,
      sortable: true,
      width: "150px",
    },

    {
      name: "Strategy Description",
      selector: (row) => row.strategy_description,
      cell: (row) => {
        const desc = row.strategy_description || "-";

        // 👉 HTML tags remove so table me clean text mile
        const plainText = desc.replace(/<[^>]+>/g, "");

        const shortDesc =
          plainText.length > 20
            ? `${plainText.substring(0, 20)}...`
            : plainText;

        return (
          <div>
            {shortDesc}{" "}
            {plainText.length > 20 && (
              <span
                className="text-primary"
                style={{
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "12px",
                }}
                onClick={() => {
                  setSelectedDescription(desc);
                  setShowDescriptionModal(true);
                }}
              >
                Read more
              </span>
            )}
          </div>
        );
      },
      sortable: true,
      width: "250px",
    },



    {
      name: "Actions",
      selector: () => null,
      cell: (row) => (
        <div className="d-flex">
          <span title="Get Clients">
            <UserPlus
              size={20}
              strokeWidth={2}
              className="mx-1"
              onClick={() => GetClientsByStrategyID(row)}
            />
          </span>
          <Link
            to={`/admin/strategies/edit/${row._id}`}
            state={row}
            title="Edit"
          >
            <Pencil
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
            />
          </Link>
          <span title="Delete">
            <Trash2
              size={20}
              color="#d83131"
              strokeWidth={2}
              className="mx-1"
              onClick={() => RemoveStrategy(row._id)}
            />
          </span>
          <span title="Get Client">
            <PlusSquare
              size={20}
              strokeWidth={2}
              className="mx-1"
              onClick={() => Add_Strategy_To_Client(row)}
            />
          </span>

          <span title="View Logs">
            <LogOut
              size={20}
              strokeWidth={2}
              className="mx-1"
              onClick={() => GetStrategyLogs(row._id)}
            />
          </span>
        </div>
      ),
      sortable: false,
      width: "20%",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div>
          {row.createdAt ? new Date(row.createdAt).toLocaleString() : "-"}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  const column = [
    {
      name: "User Name",
      selector: (row) => row?.users?.UserName || "-",
      cell: (row) => <div>{row?.users?.UserName || "-"}</div>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Lotsize",
      selector: (row) => row?.users?.license_type,
      cell: (row) => {
        const license = row?.users?.license_type;
        let label = "Live 2 Days";
        if (license === "2") label = "LIVE";
        else if (license === "1") label = "Paper Trading";

        return <span>{label}</span>;
      },
      sortable: true,
      width: "180px",
    },
    {
      name: "Go To Dashboard",
      selector: () => null,
      cell: (row) => {
        const user = row?.users || {};
        const isActive =
          user.AppLoginStatus === "1" || user.WebLoginStatus === "1";
        const isDisabled =
          user.AppLoginStatus === "0" && user.WebLoginStatus === "0";

        return (
          <button
            className={`btn ${isActive ? "btn-success" : "btn-danger"
              } btn-new-block`}
            onClick={() => goToDashboard(row)}
            disabled={isDisabled}
          >
            Click
          </button>
        );
      },
      // width: "200px",
    },
  ];

  const Add_Strategy_To_Client = async (row) => {
    setShowStrategyName(row.strategy_name);
    await dispatch(
      Add_And_Remove_Strategy_To_Client({
        _id: row._id,
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        setshowModal2(true);
        if (response.status) {
          let sclientid = [];
          let OneStategyClientArr = [];
          response.StrategyClient.forEach((element) => {
            sclientid.push(element.users._id);
            response.duplicateids.forEach((element1) => {
              if (element1.count === 1 && element.users._id === element1._id) {
                OneStategyClientArr.push(element1._id);
              }
            });
          });

          setStartegyIds(row._id);
          setOneStrategyClient(OneStategyClientArr);
          setStartegyClientIds(sclientid);
          setGetClient(response.AllClients);

        } else {
        }
      });
  };

  const GetClientsByStrategyID = async (row) => {
    await dispatch(
      Get_client_By_strategy_Id({
        _id: row._id,
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        setshowModal(true);
        if (response.status) {
          setServicesName({
            loading: false,
            data: response.data,
          });
        } else {
          setServicesName({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  useEffect(() => {
    const filteredData = originalData.filter((item) => {
      const name = item.strategy_name ? item.strategy_name.toLowerCase() : "";
      const desc = item.strategy_description
        ? item.strategy_description.toLowerCase()
        : "";
      const segment = item.strategy_segment
        ? item.strategy_segment.toLowerCase()
        : "";

      return (
        name.includes(searchInput.toLowerCase()) ||
        desc.includes(searchInput.toLowerCase()) ||
        segment.includes(searchInput.toLowerCase())
      );
    });

    setAllStrategy({
      loading: false,
      data: searchInput ? filteredData : originalData,
    });
  }, [searchInput, originalData]);

  const RemoveStrategy = async (strat_id) => {
    // ADD Swal CONFIRM box
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await dispatch(
          Remove_Strategy_BY_Id({
            _id: strat_id,
            token: user_token,
          })
        )
          .unwrap()
          .then((response) => {
            if (response.status) {
              toast.success(response.msg);
              setRefresh(!refresh);
              setTimeout(() => {
                navigate("/admin/strategies");
              }, 5000);
            } else {
              toast.error(response.msg);
            }
          });
      }
    });
  };

  const handleStrategyChecked = (event) => {
    const CheckedClientId = event.target.name;

    if (event.target.checked) {
      setStartegyClientIds([...startegyClientIds, CheckedClientId]);
      setStartegyClientIdsDelete(
        startegyClientIdsDelete.filter((item) => item !== CheckedClientId)
      );
    } else {
      setStartegyClientIdsDelete([...startegyClientIdsDelete, CheckedClientId]);
      setStartegyClientIds(
        startegyClientIds.filter((item) => item !== CheckedClientId)
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let filteredArray = startegyClientIds.filter(
      (item) => !oneStrategyClient.includes(item)
    );

    const req = {
      clientId: filteredArray,
      strategyId: startegyIds,
      clientIdDelete: startegyClientIdsDelete,
    };

    await dispatch(UpDate_strategy_Id({ req: req }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          toast.success(response.msg);
          setTimeout(() => {
            setshowModal2(false);
          }, [1000]);
        } else {
          toast.error(response.msg);
        }
      });
  };

  const goToDashboard = async (email) => {
    let req = {
      Email: email.users.Email,
    };
    await dispatch(GO_TO_DASHBOARDS(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          localStorage.setItem("gotodashboard", JSON.stringify(true));
          localStorage.setItem(
            "user_details_goTo",
            JSON.stringify(response.data)
          );
          localStorage.setItem(
            "user_role_goTo",
            JSON.stringify(response.data.Role)
          );
          localStorage.setItem("page", "strategies");

          navigate("/client/dashboard");
        }
      });
  };

  const GetStrategyLogs = async (strategyId) => {
    await dispatch(
      Get_Strategy_Logs({
        strategy_id: strategyId,
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        setShowLogsModal(true); // ✅ open modal only after fetching logs
        if (response.status) {
          setStrategyLogs(response.data);
        } else {
          setStrategyLogs([]);
        }
      });
  };


  const columns3 = [
    {
      name: "User Name",
      selector: (row) => row?.user_id?.UserName || "-",
      cell: (row) => <div>{row?.user_id?.UserName || "-"}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Description",
      selector: (row) => row?.description || "-",
      cell: (row) => {
        const desc = row?.description || "-";
        const shortDesc =
          desc.length > 20 ? `${desc.substring(0, 20)}...` : desc;

        return (
          <div>
            {shortDesc}{" "}
            {desc.length > 20 && (
              <span
                className="text-primary"
                style={{ cursor: "pointer", fontWeight: "500", fontSize: "12px" }}
                onClick={() => {
                  setSelectedLogDescription(desc);
                  setShowLogDescModal(true);
                }}
              >
                Read more
              </span>
            )}
          </div>
        );
      },
      sortable: true,
      width: "700px",
    },

    {
      name: "Edited At",
      selector: (row) => row?.created_at,
      cell: (row) => (
        <div>
          {row.created_at ? new Date(row?.created_at).toLocaleString() : "-"}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
  ];
  return (
    <Content
      Page_title="All Strategy"
      button_title="Add Strategy"
      route="/admin/strategies/add"
      button_status={permission?.Create_Strategy == 1 ? true : false}
    >
      <div className="mx-0 row filter-row mb-3 mt-3">
        <div className="col-lg-4 ps-0 col-md-6 col-10">
          <div className="mb-3">
            <input
              type="text"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="form-control"
              id="exampleFormControlInput1"
            />
          </div>
        </div>

        <div className="col-lg-2 col-2">
          <button
            className="btn btn-sm btn-primary"
            title="Reset Filters"
            onClick={() => {
              setIsSpinning(true);
              setSearchInput("");
              setRefresh((prev) => !prev);
              setTimeout(() => setIsSpinning(false), 1000);
            }}
          >
            <i className={`fa fa-refresh ${isSpinning ? "spin" : ""}`}></i>
          </button>
        </div>
      </div>

      {isLoading || isSpinning ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Loader />
        </div>
      ) : (
        <Table columns={columns} data={AllStrategy?.data || []} />
      )}

      {/* <ToastButton /> */}

      {showModal && (
        <Modal
          isOpen={showModal}
          size="lg"
          title="Clients"
          hideBtn={true}
          handleClose={() => setshowModal(false)}
        >
          <Table columns={column} data={getServicesName?.data || []} />
        </Modal>
      )}

      {showModal2 && (
        <Modal
          isOpen={showModal2}
          size="lg"
          title={showStrategyName}
          hideBtn={true}
          handleClose={() => setshowModal2(false)}
        >
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="row mb-5">
              {getClient &&
                getClient.map((client, index) => (
                  <div key={client._id} className="col-md-3 mb-3"> {/* 3 columns in a row */}
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id={client._id}
                        name={client._id}
                        value="checkboxValue"
                        defaultChecked={startegyClientIds.includes(client._id)}
                        disabled={oneStrategyClient.includes(client._id)}
                        onChange={(e) => handleStrategyChecked(e)}
                      />
                      <label className="mx-3" htmlFor={client._id}>
                        {client.UserName}
                      </label>
                      {oneStrategyClient.includes(client._id) ? (
                        <Link
                          to={`/admin/client/edit/${client._id}`}
                          state={client}
                        >
                          <span
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                          >
                            <Pencil
                              size={20}
                              color="#198754"
                              strokeWidth={2}
                              className="mx-1"
                            />
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}
            </div>
            <button className="btn btn-primary" type="submit">
              Update
            </button>
          </form>

        </Modal>
      )}

      {showLogsModal && (
        <Modal
          isOpen={showLogsModal}
          size="xl"
          title="Strategy Logs"
          handleClose={() => {
            setShowLogsModal(false);  // ✅ close modal
            setStrategyLogs(null);    // ✅ reset data
          }}
          hideBtn={true}
        >
          {Array.isArray(StrategyLogs) && StrategyLogs.length > 0 ? (
            <Table columns={columns3} data={StrategyLogs} />
          ) : (
            <div
              className="d-flex justify-content-center align-items-center text-muted"
              style={{ height: "200px", fontSize: "18px" }}
            >
              No Logs Found
            </div>
          )}
        </Modal>
      )}


      {showDescriptionModal && (
        <Modal
          isOpen={showDescriptionModal}
          size="xl"
          title="Strategy Description"
          handleClose={() => setShowDescriptionModal(false)}
          hideBtn={true}
        >
          <div
            style={{ fontSize: "16px" }}
            dangerouslySetInnerHTML={{ __html: selectedDescription }}
          ></div>

        </Modal>
      )}

      {showLogDescModal && (
        <Modal
          isOpen={showLogDescModal}
          size="xl"
          title="Full Description"
          handleClose={() => setShowLogDescModal(false)}
          hideBtn={true}
        >
          <div
            style={{ fontSize: "16px" }}
            dangerouslySetInnerHTML={{ __html: selectedLogDescription }}
          ></div>

        </Modal>
      )}


    </Content>
  );
};

export default ServicesList;
